"use strict";function multiSelect$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.multiSelect$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.multiSelect";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.0.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.0.0"},_a)),exports.multiSelect$=multiSelect$,exports.default=multiSelect$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/multiSelect.js
// module id = 1012
// module chunks = 106